import HowWeInvest from "../components/investment-thisis/how-we-invest";
import Journey from "../components/investment-thisis/investment-journey";
import MissionStrategic from "../components/investment-thisis/mission-strategic";
import Banner from "../components/ui-components/banner";
import { fetchInvestementPage } from "../services/api";
import SeoHead from '../components/SeoHead.jsx';
const Investment=({lang})=>{


    return(
        <>
         <SeoHead slug="investment" lang={lang} />
        <Banner fetchData={fetchInvestementPage} lang={lang}/>
        <MissionStrategic lang={lang} />
        <HowWeInvest lang={lang} />
        <Journey  lang={lang}/>
        </>
    );

}
export default Investment;